import { Box, Grid, Typography } from '@material-ui/core';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/styles';
import { AppContext } from 'context';
import Loading from '../../components/Loading';
import theme from '../../theme';
import { MenuProvider } from '../../menuContext';
import AdministrationLayout from './Layout';

const useStyles = makeStyles(() => ({
  backgroundImage: {
    position: 'fixed',
    bottom: 0,
    right: 0,
    height: '50vh',
  },
  title: {
    fontSize: '2.2rem',
    marginBottom: '1rem',
  },
  subtitle: {
    fontSize: '1.8rem',
  },
  primary: {
    color: theme.palette.primary.main,
  },
  content: {
    marginTop: '-40px',
    alignItems: 'center',
  },
  pictogramContainer: {
    minWidth: '420px',
  },
  pictogram: {
    filter: 'invert(36%) sepia(52%) saturate(675%) hue-rotate(141deg) brightness(90%) contrast(93%)',
  },
  textContainer: {
    maxWidth: '235px',
  },
}));

const AdministrationHomepage: React.FC = () => {
  const context = useContext(AppContext);
  const { t } = useTranslation('translation', { keyPrefix: 'administration.home' });
  const classes = useStyles();

  const user = context.user;

  if (!user) return <Loading />;

  return (
    <MenuProvider>
      <AdministrationLayout>
        <Box display="flex" flexGrow={1} justifyContent="center" flexDirection="column" marginLeft="10vw">
          <div>
            <Typography variant="h1" className={classes.title}>
              <span className={classes.primary}>
                {user.firstName} {user.lastName}
              </span>
            </Typography>
            <Typography variant="h1" className={classes.subtitle}>
              {t('subtitle')} <span className={classes.primary}>{t('application')}</span>
            </Typography>
          </div>
          <div>
            <Grid container className={classes.content}>
              <Grid item xs={4} className={classes.pictogramContainer}>
                <img className={classes.pictogram} alt="" src="/cloud-picto.png" />
              </Grid>
              <Grid item xs={4}>
                <Typography variant="body1" className={classes.textContainer}>
                  {t('content')}
                </Typography>
              </Grid>
            </Grid>
          </div>
        </Box>
        <img className={classes.backgroundImage} alt="" src="/bg-pattern.png" />
      </AdministrationLayout>
    </MenuProvider>
  );
};
export default AdministrationHomepage;
